/*
* custom
*/

// never every overwrite window.$ or window.jQuery here if fec is in use!
// this would cause $.ajaxSetup to malfunction since this file will be loaded after the fec-client.
const $ = require('jquery')
window.$ = window.$ || $
window.jQuery = window.jQuery || $
var $window = $(window);
var winWidth = $window.width()
window.Shuffle = require('../vendor/shuffle-js-5.4.1/shuffle.min.js')
const Swiper = require('swiper/swiper-bundle.min.js');
// const Shariff = require('shariff');


$(document).ready(function ($) {

	$('header .nav-button i').on('click', function(){
		var $nav = $('#mainNav');
		if ($nav.css('display')==='none') {
			$nav.css('height','calc(100vh - ' + $('header').height() + 'px)');
			// $nav.css('height','calc(100vh - ' + $('header').height() + 'px)');
			$nav.css('display','block');
			$('#butMainNavClosed').hide();
			$('#butMainNavOpened').show();
			$('html').css('overflow-y','hidden');
		} else {
			$nav.hide();
			$('#butMainNavClosed').show();
			$('#butMainNavOpened').hide();
			$('html').css('overflow-y','auto');
		}
	});

	$('#mapLoadFrame').on('click', function(e){
		var self = $(this);
		self.html('<iframe src="' + self.data('url') + '" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>');
		self.off( "click");
	});

	// handle form button
	var $btnContactForm = $('#btnContact');
	if ($btnContactForm.length) {
		$btnContactForm.click(function() {
			custom.submitForm($btnContactForm.data('frm'),false);
		});
	}

	// init press-news categories and preset 'any'
	var $shuffleContainer = $('#categoriesDataList');
	var $shuffleContainerEmptyMessage = $('#newsListEmptyByFilterMsg');
	if ($shuffleContainer.length > 0) {

		window.shuffleInstance = new window.Shuffle($shuffleContainer[0], {
			itemSelector: '.clts',
			group: 'any'
		});
		window.shuffleInstance.options.filterMode = 'all'; // force AND filter here, because the option-config doesn't work ...
		window.shuffleInstance.on(Shuffle.EventType.LAYOUT, function () { // on: things finished moving
			// no entries => show message
			if ($shuffleContainer.find('.clts.shuffle-item--visible').length) {
				$shuffleContainerEmptyMessage.hide();
			} else {
				$shuffleContainerEmptyMessage.show();
			}
		})

		$('#categories button').on('click',function () {
			// remove active class
			$('#categories button').removeClass('active');
			var $catButton = $(this);
			$catButton.addClass('active');
			custom.filterNewsList();

			// var cats = [];
			//
			// var $catButton = $('#categories button.active');
			// var catGroup = $catButton.data('cat');
			// if (catGroup!=='any')		cats.push(catGroup)
			//
			// var $ddSchoolYear = $('#schoolYearFilter');
			// var catSchoolYear = $ddSchoolYear.val();
			// if (catSchoolYear!=='any')	cats.push(catSchoolYear)
			//
			// if (!cats.length) cats.push('any');
			//
			// custom.filterNewsList(cats);
		});
		$('#schoolYearFilter').on('change',function () {
			custom.filterNewsList();
		});
		$('#newsSearchTerm').on('change',function () {
			custom.filterNewsList();
		});

	}

	// // TODO: wt: approve and / or cleanup
	// custom.eventTicker.init();
	// custom.initEventTicker();
	custom.initSwipers();
	custom.handleCookiePolicyBar();
	custom.initContentGallery();
	custom.initForms();
	// custom.addShariff();
});

$window.resize(function() {
	custom.handleCookiePolicyBar(true);
	// if (winWidth !== $window.width()) {
	// 	if ($('#mobileNav').css('display')==='block') {
	// 		$('header nav').hide();
	// 		$('#butMobileNavClose').hide();
	// 		$('#butMobileNav').show();
	// 	} else {
	// 		if ($window.width()>=1200) {
	// 			$('header nav').css('display','inline-flex');
	// 		}
	// 	}
	// }
});

$window.scroll(function() {

	if ($window.scrollTop() > 140) {
		$('header').addClass('scrolling')
	} else {
		$('header').removeClass('scrolling')
	}
});
// web-object
var custom = window.custom = {

	filterNewsList: function(){
		let cats = [];

		const $catButton = $('#categories button.active');
		const catGroup = $catButton.data('cat');
		if (catGroup!=='any')		cats.push(catGroup)

		const $ddSchoolYear = $('#schoolYearFilter');
		const catSchoolYear = $ddSchoolYear.val();
		if (catSchoolYear!=='any')	cats.push(catSchoolYear)

		const searchTerm = $('#newsSearchTerm').val().trim();
		if(searchTerm){
			return $.ajax({
				url: 	'/~/newsSearch',
				method: 'POST',
				data: 	{searchTerm},
				cache:	false,
			}).then(res => {
				const {routeIDs} = (res || {})
				this.applyNewsListFilter(cats, routeIDs);
			}).fail(res => {
				this.applyNewsListFilter(cats, {});
			});
		}

		if (!cats.length){
			cats.push('any');
		}

		this.applyNewsListFilter(cats);
	},

	applyNewsListFilter: function(cats = [], routeIDs = null){
		if(!window.shuffleInstance){
			return console.error('missing shuffleInstance')
		}

		// window.shuffleInstance.filter(cats);
		window.shuffleInstance.filter(function(element, shuffle){
			const elementRouteID = element.dataset.routeId || 0
			const elementGroups = Object.fromEntries(JSON.parse(element.dataset.groups).map(key => [key, true]))

			let catFound = cats.length < 1
			let routeIDFound = routeIDs === null || !!(routeIDs || {})[elementRouteID]

			if(!catFound){
				catFound = true
				for(const cat of Object.values(cats)){
					catFound = catFound && !!elementGroups[cat]
				}
			}

			return catFound && routeIDFound
		});

	},
	// raTypeUpdated: function (dd) {
	// 	var $ddType = $(dd);
	// 	var $ddYear = $('#ra_year');
	// 	var type = parseInt($ddType.val());
	// 	$('#ra_step3').hide();
	// 	$('#ra_result').html('');
	// 	if (!(type>0)) {
	// 		$('#ra_step2').hide();
	// 	} else {
	// 		var options = '', addYear = false, y, i;
	// 		$ddYear.html('');
	// 		for (y=0; y<(raYearLookup || []).length; y++) {
	// 			addYear = false;
	// 			for (i=0; i<(raData || []).length; i++) {
	// 				if (raData[i].year === raYearLookup[y].id && raData[i].type === type) {
	// 					addYear = true;
	// 				}
	// 			}
	// 			if (addYear) {
	// 				options += '<option value="' + raYearLookup[y].id + '">' + raYearLookup[y].name + '</option>';
	// 			}
	// 		}
	// 		$ddYear.html('<option selected value="-">Bitte wählen Sie ein Jahr!</option>' + options);
	// 		$('#ra_step2').show();
	// 	}
	// },
	// raYearUpdated: function (dd) {
	// 	var $ddYear = $(dd);
	// 	var type = parseInt($('#ra_type').val());
	// 	var year = parseInt($ddYear.val());
	//
	// 	var $list = $('#ra_result');
	// 	var data = '';
	// 	var d;
	// 	for (var i=0; i<(raData || []).length; i++) {
	// 		d = raData[i];
	// 		if (d.year === year && d.type === type) {
	// 			data += '<li><a href="' + d.url + '" target="_blank"><i class="fis fi-file-' + d.ext + '" aria-hidden="true"></i><span>' + d.name + ' (' + d.size + ')</span></a></li>';
	// 		}
	// 	}
	// 	$list.html(data);
	// 	$('#ra_step3').show();
	// },
	//
	// eventTicker: {
	// 	$eventCountdown: null,
	// 	eventCountdownInterval: null,
	// 	eventTS: null,
	//
	// 	init: function(){
	// 		this.$eventCountdown = $('#eventCountdown');
	// 		if (this.$eventCountdown.length) {
	// 			this.eventTS = this.$eventCountdown.addClass('sN').data('ets')*1;
	// 			this.update(this)
	// 			this.eventCountdownInterval = setInterval(this.update, 1000, this)
	// 		}
	// 	},
	//
	// 	update: function(self){
	// 		if(self.eventTS && self.$eventCountdown){
	// 			var now  = new Date().getTime();
	// 			var diff = self.eventTS - now;
	// 			document.getElementById('cntdwn_d').innerHTML = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2,'0');
	// 			document.getElementById('cntdwn_h').innerHTML = String(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2,'0');
	// 			document.getElementById('cntdwn_m').innerHTML = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2,'0');
	// 			document.getElementById('cntdwn_s').innerHTML = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2,'0');
	// 			if (diff <= 0) {
	// 				clearInterval(self.eventCountdownInterval);
	// 				self.$eventCountdown.hide();
	// 			}
	// 		}
	// 	}
	// },

	initForms: function() {
		var $birthDate = $('#birthDate')
		if ($birthDate.length > 0) {
			$birthDate.datepicker({
				language: 'de',
				dateFormat: 'dd.mm.yyyy',
				inline: false,
				autoClose: true,
			})
		}

	},

	validateEmail : function(email) {
		var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
		return re.test(email);
	},

	initSwipers: function() {
		var $swipers = $('.swiper-container');
		if ($swipers.length > 0) {
			$swipers.each(function () {
				if ($(this).data('slide-count') > 1) {
					var sc = {
						preloadImages: false,
						loop: true,
						lazy: true,
						autoplay: {
							delay: 5000,
							disableOnInteraction: true,
						},
						effect: 'fade',
						fadeEffect: {
							crossFade: true
						},
						navigation: {
							nextEl: '.swiper-btn-next',
							prevEl: '.swiper-btn-prev',
						},
						// pagination: {
						// 	el: '.swiper-pagination',
						// 	clickable: true
						// }
					};
					if ($(this).hasClass('gallery')) {
						sc = {
							slidesPerView: 2,
							spaceBetween: 20,
							// init: false,
							pagination: {
								el: '.swiper-pagination',
								clickable: true,
							},
							breakpoints: {
								768: {
									slidesPerView: 3,
									spaceBetween: 25,
								},
								992: {
									slidesPerView: 4,
									spaceBetween: 25,
								},
								1200: {
									slidesPerView: 5,
									spaceBetween: 25,
								},
							}
						};
					}
					new Swiper($(this)[0], sc);
				}
			});
		}
	},

	// addShariff: function() {
	// 	new Shariff($('#shariff'), {
	// 		orientation: 'horizontal',
	// 		buttonStyle: 'icon',
	// 		services: ['facebook', 'twitter', 'pinterest', 'linkedin'],
	// 		lang: 'de'
	// 	});
	// },

	submitForm : function(formID, forceSubmit)
	{
		var $form = $('#' + formID);

		// form is forced
		if (forceSubmit === true) $('#district').val('');

		// disable button
		var $button = $('#btnContact');
		$button.prop('disabled',true);

		// validate required fields
		var isValid = true;
		$('form :input, form :checked').each(function() {
			var $field = $(this);
			var fieldType = $field.attr('type');
			var fieldName = $field.attr('name');
			var fieldValue = $field.val();
			if ($field.attr('required') && (fieldValue === "" ||
				(fieldType==='email' && fieldValue !== "" && !custom.validateEmail(fieldValue)) ||
				(fieldType === 'checkbox' && !$field[0].checked))) {
				$field.addClass('is-invalid');
				isValid = false;
			} else {
				$field.removeClass('is-invalid');
			}
		});

		// prepare alert boxes
		var validationErrorMsg = 'Bitte füllen Sie alle Pflichtfelder korrekt aus und aktivieren Sie die Einverständniserklärung.';
		var $successBox = $('#frmContactSuccess');
		var $errorBox 	= $('#frmContactError');
		$successBox.hide();
		$errorBox.hide();

		if (!isValid) {
			$errorBox.html(validationErrorMsg).show();
			$button.prop('disabled',false);

		} else {

			$.ajax({
				url: 	'/~/de/sendContactForm',
				method: 'post',
				data: 	$form.serialize(),
				cache:	false,
				async: 	true

			}).done(function(res) {
				if (res.success === true) {
					$('html, body').animate({'scrollTop': $form.offset().top-50}, 400);
					$successBox.html(res.msg).show();
					$('.frmDone').hide();
				} else {
					var html;
					if (typeof res.data != 'undefined') {
						html = validationErrorMsg;
						for (var i in res.data) {
							$form.find('input[name=' + res.data[i].field + ']').addClass('is-invalid');
						}
					} else if (res.msg) {
						if (res.msg === 'honeypot-trap') {
							html = 'Der Spam-Schutz dieses Formulars hat angeschlagen.<br>Bitte ' +
								'<a href="javascript:custom.submitForm(\'' + formID + '\',true)">klicken Sie hier</a> um das Formular abzusenden.';
						} else {
							html = '<b>' + res.msg + '</b><br>';
						}
					} else {
						html = '<b>Beim Versenden des Formulars ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmal oder senden Sie Ihre Anfrage direkt an info@pfadfinder-muelln.at.</b>';
					}
					$errorBox.html(html).show();
					$button.prop('disabled',false);
				}
			}).fail(function(res) {
				$errorBox.html(res.data).show();
				$button.prop('disabled',false);
			});
		}
	},

	handleCookiePolicyBar: function(resizeCall) {

		if (typeof resizeCall === "undefined") resizeCall = false;
		var cookieName = "NECESSARY_COOKIES_ACCEPTED";
		// cookie-policy-bar must be displayed
		if (document.cookie.indexOf(cookieName)===-1) {
			var $cookiePolicyBar = $('.cookie-policy-bar');
			//show bar and
			$cookiePolicyBar.show();
			// handle button action
			if (!resizeCall) {
				$cookiePolicyBar.find('button').on('click',function(){
					// set cookie to remember
					var d = new Date();
					d.setTime(d.getTime() + (31*24*60*60*1000));
					document.cookie = cookieName + "=true;expires=" + d.toUTCString() + ";path=/";
					// remove cookie-bar
					$(this).parent().hide();
				});
			}
		}
	},

	initContentGallery: function () {
		var $galleries = $('.gallery-wrapper, .lightbox-init');
		if ($galleries.length > 0) {
			$galleries.each(function(index) {
				var $gallery = $(this);
				var galleryData = $gallery.data('gallery');
				if (!galleryData) return;
				var entries = galleryData.split('||');
				var items = [];
				for (var i=0;i<entries.length;i++) {
					var img = entries[i].split('##');
					if (img.length === 3) {
						items.push({
							w: 		img[0],
							h:		img[1],
							src:	img[2]
						});
					}
				}
				$gallery.find('img').each(function(imgIndex) {
					$(this).on('click',function(e){
						custom.openLightBox(
							items,
							{ index: imgIndex } // start with this slide
						);
					});
				});
			});
		}
	},

	openLightBox: function(items, options) {
		var pswpElement = document.getElementById('pswp');
		var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();
	}
};

/**
 * String.prototype.padStart() polyfill
 * https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
 */
// if (!String.prototype.padStart) {
// 	String.prototype.padStart = function padStart(targetLength,padString) {
// 		targetLength = targetLength>>0; //truncate if number or convert non-number to 0;
// 		padString = String((typeof padString !== 'undefined' ? padString : ' '));
// 		if (this.length > targetLength) {
// 			return String(this);
// 		}
// 		else {
// 			targetLength = targetLength-this.length;
// 			if (targetLength > padString.length) {
// 				padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
// 			}
// 			return padString.slice(0,targetLength) + String(this);
// 		}
// 	};
// }